module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"NOTACESS":"Forbidden","LOST":"You don\u0027t have permission to access.","GOHOME":"Go Home"},"ar":{"NOTFOUND":"ممنوع","LOST":"ليس لديك إذن للوصول.","GOHOME":"اذهب للمنزل"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/403.vue
// module id = 294
// module chunks = 1